import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-rate/es/index.js
// module id = 1456
// module chunks = 0